import { useState } from "react";

/** The time the component mounted; fixed across re-renders so render stays pure */
export function useMountDate(): Date {
  // oxlint-disable-next-line react/hook-use-state -- Snapshots the time on mount; there is deliberately no setter
  const [date] = useState(() => new Date());
  return date;
}
